var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500244,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#1D1C1B",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0363 16.8794H17.378L17.1446 16.6544C17.9613 15.7044 18.453 14.4711 18.453 13.1294C18.453 10.1377 16.028 7.71274 13.0363 7.71274C10.0446 7.71274 7.61963 10.1377 7.61963 13.1294C7.61963 16.1211 10.0446 18.5461 13.0363 18.5461C14.378 18.5461 15.6113 18.0544 16.5613 17.2377L16.7863 17.4711V18.1294L20.953 22.2877L22.1946 21.0461L18.0363 16.8794ZM13.0363 16.8794C10.9613 16.8794 9.2863 15.2044 9.2863 13.1294C9.2863 11.0544 10.9613 9.3794 13.0363 9.3794C15.1113 9.3794 16.7863 11.0544 16.7863 13.1294C16.7863 15.2044 15.1113 16.8794 13.0363 16.8794ZM12.6196 12.7127V11.0461H13.453V12.7127H15.1196V13.5461H13.453V15.2127H12.6196V13.5461H10.953V12.7127H12.6196Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomin);
export default __webpack_public_path__ + "static/media/zoomin.48e5f0e8a13268fca2af57f9fc20189b.svg";
export { ForwardRef as ReactComponent };